import React from 'react';
import IconMapEnlarge from '@spothero/icons/expand';
import { Button, Icon, Box } from '@spothero/ui';
import SpotDetailsDirectionsMap from '../directions-map';
import SpotDetailsDirectionsMapModal from '../directions-map-modal';
const SpotDetailsPanelMap = (props) => {
    const [showModal, setShowModal] = React.useState(false);
    const { spotLatitude, spotLongitude, destinationLatitude, destinationLongitude, isDriving, linearMeters, walkingMeters, walkingDuration, } = props;
    const walkingProps = {
        linearMeters,
        walkingMeters,
        walkingDuration,
    };
    const setShowModalToTrue = () => setShowModal(true);
    const setShowModalToFalse = () => setShowModal(false);
    return (<Box position="relative">
            <SpotDetailsDirectionsMap isDraggable={false} spotLatitude={spotLatitude} spotLongitude={spotLongitude} destinationLatitude={destinationLatitude} destinationLongitude={destinationLongitude} isDriving={isDriving} disableDefaultUI onClick={setShowModalToTrue} {...(!isDriving && walkingProps)}/>
            <Button backgroundColor="white" position="absolute" top={1} right={1} height={10} width={10} padding={0} borderRadius="md" shadow="base" display="flex" alignItems="center" justifyContent="center" borderWidth={0} _hover={{ backgroundColor: 'gray.200' }} onClick={setShowModalToTrue}>
                <Icon color="gray.600" as={IconMapEnlarge} height={5} width={5}/>
            </Button>
            {showModal && (<SpotDetailsDirectionsMapModal spotLatitude={spotLatitude} spotLongitude={spotLongitude} destinationLatitude={destinationLatitude} destinationLongitude={destinationLongitude} isDriving={isDriving} onHidden={setShowModalToFalse} {...(!isDriving && walkingProps)}/>)}
        </Box>);
};
export default SpotDetailsPanelMap;
